module.exports = __webpack_public_path__ + "static/media/directional-down-arrow.f64ad42a.svg";